module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "checkins"
  }, [_c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.checkins && _vm.mentees) ? _c('ul', {
    staticClass: "checkins"
  }, _vm._l((_vm.checkins), function(checkin) {
    return (_vm.isFirstInWeek(checkin)) ? _c('li', {
      class: {
        'disabled': _vm.isNotActive(checkin.startDate)
      },
      attrs: {
        "id": 'checkin_' + checkin.id
      }
    }, [_c('div', {
      staticClass: "row checkin"
    }, [(_vm.localStorage.roles.includes('Student') || _vm.localStorage.roles.includes('CampusStudent')) ? _c('div', {
      staticClass: "thumbnail-image col-sm-1"
    }, [(checkin.checkin && checkin.checkin.demo_reel_update) ? _c('img', {
      attrs: {
        "src": checkin.checkin.demo_reel_update.files[0].thumbnail
      }
    }) : _vm._e(), _vm._v(" "), (checkin.checkin && checkin.checkin.demo_reel_update) ? _c('div', {
      staticClass: "blue-stripe"
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "main",
      class: {
        'col-sm-10': _vm.localStorage.roles.includes('Student') || _vm.localStorage.roles.includes('CampusStudent'),
          'col-sm-11': _vm.localStorage.roles.includes('Mentor')
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectCheckin(checkin.id)
        }
      }
    }, [(!_vm.submitted(checkin) || !checkin.checkin.demo_reel_update) ? _c('div', {
      staticClass: "blue-stripe"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6"
    }, [(_vm.isOnlineStudent) ? _c('h3', [_vm._v("Week " + _vm._s(checkin.week))]) : _c('h3', [_vm._v(_vm._s(_vm._f("checkinDate")(checkin.startDate)))]), _vm._v(" "), _c('div', {
      staticClass: "status-line"
    }, [(_vm.submitted(checkin)) ? _c('i', {
      staticClass: "status-icon fa fa-check"
    }) : _vm._e(), _vm._v(" "), (_vm.isOverdue(checkin) && !_vm.submitted(checkin)) ? _c('i', {
      staticClass: "status-icon fa fa-times animated"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "status-date",
      attrs: {
        "title": _vm.formatFullDate(checkin.dueDate)
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm.formatShortDate(checkin.dueDate)) + "\n                                    ")]), _vm._v(" "), (_vm.isOverdue(checkin) && !_vm.submitted(checkin)) ? _c('span', {
      staticClass: "status-extra status-extra-bad"
    }, [_vm._v("\n                                        Past Due\n                                    ")]) : _vm._e(), _vm._v(" "), (!_vm.isOverdue(checkin) && !_vm.submitted(checkin)) ? _c('span', {
      staticClass: "status-extra"
    }, [_vm._v("\n                                        Due\n                                    ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "icon col-sm-1"
    }, [(!checkin.checkin) ? _c('i', {
      staticClass: "fa fa-question"
    }) : _vm._e(), _vm._v(" "), (checkin.checkin && checkin.checkin.overallStatus === 'excellent') ? _c('img', {
      attrs: {
        "src": require("../assets/img/mood-excellent.svg")
      }
    }) : _vm._e(), _vm._v(" "), (checkin.checkin && checkin.checkin.overallStatus === 'good') ? _c('img', {
      attrs: {
        "src": require("../assets/img/mood-good.svg")
      }
    }) : _vm._e(), _vm._v(" "), (checkin.checkin && checkin.checkin.overallStatus === 'meh') ? _c('img', {
      attrs: {
        "src": require("../assets/img/mood-meh.svg")
      }
    }) : _vm._e(), _vm._v(" "), (checkin.checkin && checkin.checkin.overallStatus === 'bad') ? _c('img', {
      attrs: {
        "src": require("../assets/img/mood-not-great.svg")
      }
    }) : _vm._e(), _vm._v(" "), (checkin.checkin && !checkin.checkin.overallStatus && _vm.localStorage.roles.includes('Mentor')) ? _c('img', {
      attrs: {
        "src": require("../assets/img/mood-excellent.svg")
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [(!_vm.localStorage.roles.includes('Mentor')) ? _c('div', [(_vm.openCheckin == checkin.id && !checkin.checkin) ? _c('div', {
      staticClass: "scroll-wrapper col-xs-10 col-xs-push-1"
    }, [_c('scroll-area', {
      ref: "scrollbar",
      refInFor: true,
      attrs: {
        "showScrollbar": true,
        "dragScrollEnabled": false
      }
    }, [_c('form', {
      staticClass: "checkin",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.submitCheckin(checkin.id, checkin.week)
        }
      }
    }, [_c('h4', [_vm._v("Weekly Check-In")]), _vm._v(" "), (!_vm.isAlumni) ? _c('div', {
      staticClass: "attended"
    }, [_c('label', {
      staticClass: "heading"
    }, [_vm._v("Did you attend your mentorship session this week?")]), _vm._v(" "), _c('div', {
      staticClass: "radio-wrapper"
    }, [_c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.studentAttended),
        expression: "studentAttended"
      }],
      attrs: {
        "type": "radio",
        "value": "yes"
      },
      domProps: {
        "checked": _vm._q(_vm.studentAttended, "yes")
      },
      on: {
        "__c": function($event) {
          _vm.studentAttended = "yes"
        }
      }
    }), _c('span', {
      staticClass: "dot"
    }), _vm._v("\n                                                        Yes\n                                                    ")])]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.studentAttended),
        expression: "studentAttended"
      }],
      attrs: {
        "type": "radio",
        "value": "no"
      },
      domProps: {
        "checked": _vm._q(_vm.studentAttended, "no")
      },
      on: {
        "__c": function($event) {
          _vm.studentAttended = "no"
        }
      }
    }), _c('span', {
      staticClass: "dot"
    }), _vm._v("\n                                                        No\n                                                    ")])])])]) : _vm._e(), _vm._v(" "), (_vm.studentAttended === 'yes') ? _c('div', {
      staticClass: "form-group"
    }, [(_vm.isAlumni) ? _c('label', {
      staticClass: "heading"
    }, [_vm._v("How was your week?")]) : _c('label', {
      staticClass: "heading"
    }, [_vm._v("How was your mentorship session?")]), _vm._v(" "), _c('div', {
      staticClass: "radio-wrapper"
    }, _vm._l((_vm.statuses), function(status) {
      return _c('div', [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.newCheckin.overallStatus),
          expression: "newCheckin.overallStatus"
        }],
        attrs: {
          "type": "radio",
          "name": "overallStatus"
        },
        domProps: {
          "value": status.value,
          "checked": _vm._q(_vm.newCheckin.overallStatus, status.value)
        },
        on: {
          "__c": function($event) {
            _vm.newCheckin.overallStatus = status.value
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "dot"
      }), _vm._v("\n                                                        " + _vm._s(status.label) + "\n                                                    ")])])
    })), _vm._v(" "), _c('label', [_vm._v("Please share a few words about how your "), (!_vm.isAlumni) ? _c('span', [_vm._v("mentorship session(s) this")]) : _vm._e(), _vm._v(" week went.")]), _vm._v(" "), _c('div', {
      staticClass: "textarea-wrapper"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newCheckin.mentorshipStatusDetails),
        expression: "newCheckin.mentorshipStatusDetails"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (_vm.newCheckin.mentorshipStatusDetails)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newCheckin.mentorshipStatusDetails = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.studentAttended === 'no') ? _c('div', [_c('label', {
      staticClass: "heading"
    }, [_vm._v("Why were you unable to attend?")]), _vm._v(" "), _c('div', {
      staticClass: "textarea-wrapper"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newCheckin.reasonMissed),
        expression: "newCheckin.reasonMissed"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (_vm.newCheckin.reasonMissed)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newCheckin.reasonMissed = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (!_vm.isAlumni) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "heading"
    }, [_vm._v("\n                                                How is your progress so far?\n                                            ")]), _vm._v(" "), _c('div', {
      staticClass: "radio-wrapper"
    }, _vm._l((_vm.statuses), function(status) {
      return _c('div', [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.newCheckin.mentorshipStatus),
          expression: "newCheckin.mentorshipStatus"
        }],
        attrs: {
          "type": "radio",
          "name": "mentorshipStatus"
        },
        domProps: {
          "value": status.value,
          "checked": _vm._q(_vm.newCheckin.mentorshipStatus, status.value)
        },
        on: {
          "__c": function($event) {
            _vm.newCheckin.mentorshipStatus = status.value
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "dot"
      }), _vm._v("\n                                                        " + _vm._s(status.label) + "\n                                                    ")])])
    }))]) : _vm._e(), _vm._v(" "), (!_vm.isAlumni) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "heading"
    }, [_vm._v("\n                                                Please share a few words about how your mentorship is going overall. "), _c('sup', [_vm._v("(optional)")])]), _vm._v(" "), _c('div', {
      staticClass: "textarea-wrapper"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newCheckin.overallStatusDetails),
        expression: "newCheckin.overallStatusDetails"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (_vm.newCheckin.overallStatusDetails)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newCheckin.overallStatusDetails = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.localStorage.roles.includes('CampusStudent')) ? _c('div', {
      staticClass: "form-group"
    }, [(_vm.isAlumni) ? _c('span', [_vm._v("\n                                                If you need IT / Machine support please "), _c('router-link', {
      attrs: {
        "to": "/help"
      }
    }, [_vm._v("create a support ticket")]), _vm._v(".\n                                            ")], 1) : _c('span', [_vm._v("\n                                                If you need IT / Machine support please "), _c('a', {
      attrs: {
        "href": "https://www.wrike.com/frontend/requestforms/index.html?token=eyJhY2NvdW50SWQiOjkyNjY5NSwidGFza0Zvcm1JZCI6MjM3MzkwfQk0NzIyNjA0MzY3NjAwCTlmMGQ1MzM0YTMxNjk4NDhkZmVhYmEyMTY0YmViY2U2MmEyZmZmYmRmNjYyODc3NWNmMjNlZTk2ZjI0MTFjMWI=",
        "target": "_blank"
      }
    }, [_vm._v("complete this form")]), _vm._v(".\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.isAlumni) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "heading"
    }, [_vm._v("How often are you using a workstation at Think Tank?")]), _vm._v(" "), _c('div', {
      staticClass: "radio-wrapper"
    }, [_c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newCheckin.workstationUsage),
        expression: "newCheckin.workstationUsage"
      }],
      attrs: {
        "type": "radio",
        "name": "workstationUsage",
        "value": "over_60"
      },
      domProps: {
        "checked": _vm._q(_vm.newCheckin.workstationUsage, "over_60")
      },
      on: {
        "__c": function($event) {
          _vm.newCheckin.workstationUsage = "over_60"
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dot"
    }), _vm._v("\n                                                        More than 60 hours per week\n                                                    ")])]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newCheckin.workstationUsage),
        expression: "newCheckin.workstationUsage"
      }],
      attrs: {
        "type": "radio",
        "name": "workstationUsage",
        "value": "over_40"
      },
      domProps: {
        "checked": _vm._q(_vm.newCheckin.workstationUsage, "over_40")
      },
      on: {
        "__c": function($event) {
          _vm.newCheckin.workstationUsage = "over_40"
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dot"
    }), _vm._v("\n                                                        More than 40 hours per week\n                                                    ")])]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newCheckin.workstationUsage),
        expression: "newCheckin.workstationUsage"
      }],
      attrs: {
        "type": "radio",
        "name": "workstationUsage",
        "value": "over_20"
      },
      domProps: {
        "checked": _vm._q(_vm.newCheckin.workstationUsage, "over_20")
      },
      on: {
        "__c": function($event) {
          _vm.newCheckin.workstationUsage = "over_20"
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dot"
    }), _vm._v("\n                                                        More than 20 hours per week\n                                                    ")])]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newCheckin.workstationUsage),
        expression: "newCheckin.workstationUsage"
      }],
      attrs: {
        "type": "radio",
        "name": "workstationUsage",
        "value": "over_10"
      },
      domProps: {
        "checked": _vm._q(_vm.newCheckin.workstationUsage, "over_10")
      },
      on: {
        "__c": function($event) {
          _vm.newCheckin.workstationUsage = "over_10"
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dot"
    }), _vm._v("\n                                                        More than 10 hours per week\n                                                    ")])]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newCheckin.workstationUsage),
        expression: "newCheckin.workstationUsage"
      }],
      attrs: {
        "type": "radio",
        "name": "workstationUsage",
        "value": "under_10"
      },
      domProps: {
        "checked": _vm._q(_vm.newCheckin.workstationUsage, "under_10")
      },
      on: {
        "__c": function($event) {
          _vm.newCheckin.workstationUsage = "under_10"
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dot"
    }), _vm._v("\n                                                        Less than 10 hours per week\n                                                    ")])]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newCheckin.workstationUsage),
        expression: "newCheckin.workstationUsage"
      }],
      attrs: {
        "type": "radio",
        "name": "workstationUsage",
        "value": "never"
      },
      domProps: {
        "checked": _vm._q(_vm.newCheckin.workstationUsage, "never")
      },
      on: {
        "__c": function($event) {
          _vm.newCheckin.workstationUsage = "never"
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dot"
    }), _vm._v("\n                                                        Not at all\n                                                    ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "checkbox-wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newCheckin.important),
        expression: "newCheckin.important"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.newCheckin.important) ? _vm._i(_vm.newCheckin.important, null) > -1 : (_vm.newCheckin.important)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.newCheckin.important,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.newCheckin.important = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.newCheckin.important = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.newCheckin.important = $$c
          }
        }
      }
    }), _vm._v("\n                                                Mark this as important for Think Tank staff to see and be notified.\n                                            ")])]), _vm._v(" "), (_vm.localStorage.roles.includes('Student') || _vm.localStorage.roles.includes('CampusStudent')) ? _c('div', [_c('h5', [_vm._v("Your Demo Reel")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "heading"
    }, [_vm._v("\n                                                    Please attach at least one image or video (mp4) to update Think Tank on your progress.\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "dropzone-wrapper"
    }, [_c('dropzone', {
      ref: "checkinFiles",
      refInFor: true,
      attrs: {
        "id": "checkinFiles",
        "url": "#",
        "use-custom-dropzone-options": true,
        "thumbnail-height": 0,
        "dropzone-options": _vm.dropzoneOptions
      }
    })], 1)])]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "type": "submit",
        "disabled": _vm.isSubmitting
      }
    }, [_vm._v("Submit Check-In")])])])], 1) : _vm._e(), _vm._v(" "), (checkin.checkin && _vm.openCheckin == checkin.id) ? _c('div', {
      staticClass: "scroll-wrapper col-xs-10 col-xs-push-1"
    }, [_c('scroll-area', {
      ref: "scrollbar",
      refInFor: true,
      attrs: {
        "showScrollbar": true,
        "dragScrollEnabled": false
      }
    }, [_c('div', {
      staticClass: "completed-checkin"
    }, [_c('div', [_c('h4', [_vm._v("Weekly Check-In")]), _vm._v(" "), (checkin.checkin.reasonMissed) ? _c('div', [_c('label', {
      staticClass: "heading"
    }, [_vm._v("Why were you unable to attend?")]), _vm._v(" "), _c('div', {
      staticClass: "textarea-wrapper"
    }, [_c('textarea', {
      staticClass: "form-control",
      attrs: {
        "readonly": ""
      },
      domProps: {
        "value": checkin.checkin.reasonMissed
      }
    })])]) : _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "heading"
    }, [_vm._v("How was your mentorship session?")]), _vm._v(" "), _c('div', {
      staticClass: "radio-wrapper"
    }, _vm._l((_vm.statuses), function(status) {
      return _c('div', [_c('label', [_c('span', {
        staticClass: "dot",
        class: {
          'selected': status.value === checkin.checkin.overallStatus
        }
      }), _vm._v("\n                                                            " + _vm._s(status.label) + "\n                                                        ")])])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Please share a few words about how your mentorship session(s) this week went.")]), _vm._v(" "), _c('div', {
      staticClass: "textarea-wrapper"
    }, [_c('textarea', {
      staticClass: "form-control",
      attrs: {
        "readonly": ""
      },
      domProps: {
        "value": checkin.checkin.mentorshipStatusDetails
      }
    })])]), _vm._v(" "), (!_vm.isAlumni) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "heading"
    }, [_vm._v("How is your progress so far?")]), _vm._v(" "), _c('div', {
      staticClass: "radio-wrapper"
    }, _vm._l((_vm.statuses), function(status) {
      return _c('div', [_c('label', [_c('span', {
        staticClass: "dot",
        class: {
          'selected': status.value === checkin.checkin.mentorshipStatus
        }
      }), _vm._v("\n                                                            " + _vm._s(status.label) + "\n                                                        ")])])
    }))]) : _vm._e(), _vm._v(" "), (!_vm.isAlumni) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "heading"
    }, [_vm._v("\n                                                    Please share a few words about how your mentorship is going overall.\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "textarea-wrapper"
    }, [_c('textarea', {
      staticClass: "form-control",
      attrs: {
        "readonly": ""
      },
      domProps: {
        "value": checkin.checkin.overallStatusDetails
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "submission-date"
    }, [_vm._v("\n                                                Submitted on " + _vm._s(_vm.formatFullDate(checkin.checkin.createdAt)) + "\n                                            ")])]), _vm._v(" "), (_vm.localStorage.roles.includes('Student') || _vm.localStorage.roles.includes('CampusStudent')) ? _c('div', {
      staticClass: "completed-demo-reel"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "heading"
    }, [_vm._v("\n                                                    Please attach at least one image or video (mp4) to update Think Tank on your progress.\n                                                ")]), _vm._v(" "), _c('ul', {
      staticClass: "files demo-reel-thumbs"
    }, _vm._l((checkin.checkin.demo_reel_update.files), function(file) {
      return _c('li', [_c('a', {
        attrs: {
          "href": file.file,
          "target": "_blank"
        }
      }, [_c('img', {
        attrs: {
          "src": file.thumbnail
        }
      })])])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "submission-date"
    }, [_vm._v("\n                                                Submitted on " + _vm._s(_vm.formatFullDate(checkin.checkin.demo_reel_update.updatedAt)) + "\n                                            ")])]) : _vm._e()])])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mentees && _vm.openCheckin === checkin.id && _vm.localStorage.roles.includes('Mentor')) ? _c('div', {
      staticClass: "col-xs-11 mentees"
    }, [_c('h4', [_vm._v("Student Evaluations")]), _vm._v(" "), _c('p', [_vm._v("Please complete your evaluations after your session(s) this week.")]), _vm._v(" "), _c('div', {
      staticClass: "tabs"
    }, [_c('ul', {
      staticClass: "clearfix"
    }, _vm._l((_vm.mentees), function(mentee, $menteeIndex) {
      return _c('li', {
        class: {
          'active': _vm.selectedStudent === $menteeIndex
        },
        on: {
          "click": function($event) {
            _vm.selectedStudent = $menteeIndex
          }
        }
      }, [_vm._v("\n                                        " + _vm._s(mentee.firstName) + " " + _vm._s(mentee.lastName) + "\n                                    ")])
    }))]), _vm._v(" "), _vm._l((_vm.mentees), function(mentee, $menteeIndex) {
      return (_vm.selectedStudent === $menteeIndex) ? _c('div', {
        staticClass: "row"
      }, [(_vm.hasEvaluation(checkin, mentee.id)) ? _c('div', [_c('weekly-evaluation', {
        attrs: {
          "checkin": checkin,
          "studentId": mentee.id,
          "statuses": _vm.statuses
        }
      })], 1) : _c('div', [(_vm.getMeetingForWeek(checkin, mentee.meetings) && _vm.getMeetingForWeek(checkin, mentee.meetings).location && _vm.getMeetingForWeek(checkin, mentee.meetings).location !== 'remote') ? _c('div', [_c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "heading"
      }, [_vm._v("Did you have your sessions with " + _vm._s(mentee.firstName) + " " + _vm._s(mentee.lastName) + " this week?")]), _vm._v(" "), _c('div', {
        staticClass: "radio-wrapper"
      }, [_c('div', [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.campusMentorAttended),
          expression: "campusMentorAttended"
        }],
        attrs: {
          "type": "radio",
          "value": "yes"
        },
        domProps: {
          "checked": _vm._q(_vm.campusMentorAttended, "yes")
        },
        on: {
          "__c": function($event) {
            _vm.campusMentorAttended = "yes"
          }
        }
      }), _c('span', {
        staticClass: "dot"
      }), _vm._v("\n                                                        Yes\n                                                    ")])]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.campusMentorAttended),
          expression: "campusMentorAttended"
        }],
        attrs: {
          "type": "radio",
          "value": "no"
        },
        domProps: {
          "checked": _vm._q(_vm.campusMentorAttended, "no")
        },
        on: {
          "__c": function($event) {
            _vm.campusMentorAttended = "no"
          }
        }
      }), _c('span', {
        staticClass: "dot"
      }), _vm._v("\n                                                        No\n                                                    ")])])])]), _vm._v(" "), (_vm.campusMentorAttended === 'yes') ? _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "heading"
      }, [_vm._v("How was your mentorship session(s) in relation to " + _vm._s(mentee.firstName) + " " + _vm._s(mentee.lastName) + "?")]), _vm._v(" "), _c('div', {
        staticClass: "radio-wrapper"
      }, _vm._l((_vm.statuses), function(status) {
        return _c('div', [_c('label', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.newCheckin.students[$menteeIndex].participation),
            expression: "newCheckin.students[$menteeIndex].participation"
          }],
          attrs: {
            "type": "radio",
            "name": "participation"
          },
          domProps: {
            "value": status.value,
            "checked": _vm._q(_vm.newCheckin.students[$menteeIndex].participation, status.value)
          },
          on: {
            "__c": function($event) {
              _vm.newCheckin.students[$menteeIndex].participation = status.value
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "dot"
        }), _vm._v("\n                                                        " + _vm._s(status.label) + "\n                                                    ")])])
      })), _vm._v(" "), _c('label', {
        staticClass: "heading"
      }, [_vm._v("Please share a few words about how your mentorship session went and what was covered in relation to " + _vm._s(mentee.firstName) + " " + _vm._s(mentee.lastName))]), _vm._v(" "), _c('div', {
        staticClass: "textarea-wrapper"
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.newCheckin.students[$menteeIndex].sessionComments),
          expression: "newCheckin.students[$menteeIndex].sessionComments"
        }],
        staticClass: "form-control",
        domProps: {
          "value": (_vm.newCheckin.students[$menteeIndex].sessionComments)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.newCheckin.students[$menteeIndex].sessionComments = $event.target.value
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (_vm.campusMentorAttended === 'no') ? _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "heading"
      }, [_vm._v("We see you missed your meeting this week with " + _vm._s(mentee.firstName) + " " + _vm._s(mentee.lastName) + ", what happened?")]), _vm._v(" "), _c('div', {
        staticClass: "textarea-wrapper"
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.newCheckin.students[$menteeIndex].reasonMissed),
          expression: "newCheckin.students[$menteeIndex].reasonMissed"
        }],
        staticClass: "form-control",
        domProps: {
          "value": (_vm.newCheckin.students[$menteeIndex].reasonMissed)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.newCheckin.students[$menteeIndex].reasonMissed = $event.target.value
          }
        }
      })])]) : _vm._e()]) : _c('div', [(!_vm.getMeetingForWeek(checkin, mentee.meetings) || !_vm.getMeetingForWeek(checkin, mentee.meetings).attendees.includes(_vm.localStorage.user_id.toString())) ? _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "heading"
      }, [_vm._v("We see you missed your meeting this week with " + _vm._s(mentee.firstName) + " " + _vm._s(mentee.lastName) + ", what happened?")]), _vm._v(" "), _c('div', {
        staticClass: "textarea-wrapper"
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.newCheckin.students[$menteeIndex].reasonMissed),
          expression: "newCheckin.students[$menteeIndex].reasonMissed"
        }],
        staticClass: "form-control",
        domProps: {
          "value": (_vm.newCheckin.students[$menteeIndex].reasonMissed)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.newCheckin.students[$menteeIndex].reasonMissed = $event.target.value
          }
        }
      })])]) : _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "heading"
      }, [_vm._v("How was your mentorship session(s) in relation to " + _vm._s(mentee.firstName) + " " + _vm._s(mentee.lastName) + "?")]), _vm._v(" "), _c('div', {
        staticClass: "radio-wrapper"
      }, _vm._l((_vm.statuses), function(status) {
        return _c('div', [_c('label', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.newCheckin.students[$menteeIndex].participation),
            expression: "newCheckin.students[$menteeIndex].participation"
          }],
          attrs: {
            "type": "radio",
            "name": "participation"
          },
          domProps: {
            "value": status.value,
            "checked": _vm._q(_vm.newCheckin.students[$menteeIndex].participation, status.value)
          },
          on: {
            "__c": function($event) {
              _vm.newCheckin.students[$menteeIndex].participation = status.value
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "dot"
        }), _vm._v("\n                                                        " + _vm._s(status.label) + "\n                                                    ")])])
      })), _vm._v(" "), _c('label', {
        staticClass: "heading"
      }, [_vm._v("Please share a few words about how your mentorship session went and what was covered in relation to " + _vm._s(mentee.firstName) + " " + _vm._s(mentee.lastName))]), _vm._v(" "), _c('div', {
        staticClass: "textarea-wrapper"
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.newCheckin.students[$menteeIndex].sessionComments),
          expression: "newCheckin.students[$menteeIndex].sessionComments"
        }],
        staticClass: "form-control",
        domProps: {
          "value": (_vm.newCheckin.students[$menteeIndex].sessionComments)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.newCheckin.students[$menteeIndex].sessionComments = $event.target.value
          }
        }
      })])])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "heading"
      }, [_vm._v("How was " + _vm._s(mentee.firstName) + " " + _vm._s(mentee.lastName) + "'s progress this week?")]), _vm._v(" "), _c('div', {
        staticClass: "radio-wrapper"
      }, _vm._l((_vm.statuses), function(status) {
        return _c('div', [_c('label', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.newCheckin.students[$menteeIndex].progress),
            expression: "newCheckin.students[$menteeIndex].progress"
          }],
          attrs: {
            "type": "radio",
            "name": "progress"
          },
          domProps: {
            "value": status.value,
            "checked": _vm._q(_vm.newCheckin.students[$menteeIndex].progress, status.value)
          },
          on: {
            "__c": function($event) {
              _vm.newCheckin.students[$menteeIndex].progress = status.value
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "dot"
        }), _vm._v("\n                                                    " + _vm._s(status.label) + "\n                                                ")])])
      }))]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [((mentee.roles.includes('CampusStudent') || mentee.transitioned === true) && !_vm.isRemote(_vm.getMeetingForWeek(checkin, mentee.meetings))) ? _c('div', [(!_vm.hasEvaluation(checkin, mentee.id)) ? _c('label', {
        staticClass: "heading"
      }, [(_vm.campusMentorAttended == 'no') ? _c('span', [_vm._v("\n                                                    Please share a few words about " + _vm._s(mentee.firstName) + " " + _vm._s(mentee.lastName) + "'s progress this week, including how they're progressing and what they're working on.\n                                                ")]) : _c('span', [_vm._v("\n                                                    Please share a few words about " + _vm._s(mentee.firstName) + " " + _vm._s(mentee.lastName) + " progress this week, including how they're progressing and what they're working on.\n                                                ")])]) : _vm._e()]) : _c('div', [(!_vm.hasEvaluation(checkin, mentee.id)) ? _c('label', {
        staticClass: "heading"
      }, [(!_vm.attended(checkin)) ? _c('span', [_vm._v("\n                                                    Please share a few words about " + _vm._s(mentee.firstName) + " " + _vm._s(mentee.lastName) + "'s progress this week, including how they're progressing and what they're working on.\n                                                ")]) : _c('span', [_vm._v("\n                                                    Please share a few words about " + _vm._s(mentee.firstName) + " " + _vm._s(mentee.lastName) + " progress this week, including how they're progressing and what they're working on.\n                                                ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "textarea-wrapper"
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.newCheckin.students[$menteeIndex].comments),
          expression: "newCheckin.students[$menteeIndex].comments"
        }],
        staticClass: "form-control",
        domProps: {
          "value": (_vm.newCheckin.students[$menteeIndex].comments)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.newCheckin.students[$menteeIndex].comments = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "checkbox-wrapper"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.newCheckin.students[$menteeIndex].important),
          expression: "newCheckin.students[$menteeIndex].important"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(_vm.newCheckin.students[$menteeIndex].important) ? _vm._i(_vm.newCheckin.students[$menteeIndex].important, null) > -1 : (_vm.newCheckin.students[$menteeIndex].important)
        },
        on: {
          "__c": function($event) {
            var $$a = _vm.newCheckin.students[$menteeIndex].important,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.newCheckin.students[$menteeIndex].important = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.newCheckin.students[$menteeIndex].important = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.newCheckin.students[$menteeIndex].important = $$c
            }
          }
        }
      }), _vm._v("\n                                            Mark this as important for Think Tank staff to see and be notified.\n                                        ")])]), _vm._v(" "), (!_vm.hasEvaluation(checkin, mentee.id)) ? _c('button', {
        staticClass: "btn btn-success submit-evaluation",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.submitEvaluation(_vm.newCheckin.students[$menteeIndex], checkin, _vm.getMeetingForWeek(checkin, mentee.meetings))
          }
        }
      }, [_vm._v("Save Evaluation")]) : _vm._e()])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "pagination"
    }, [_c('span', [_vm._v("Student " + _vm._s(_vm.selectedStudent + 1) + " / " + _vm._s(_vm.mentees.length))]), _vm._v(" "), _c('ul', _vm._l((_vm.mentees), function(mentee, $menteeIndex) {
      return _c('li', [_c('span', {
        staticClass: "dot",
        class: {
          'selected': _vm.selectedStudent === $menteeIndex
        },
        on: {
          "click": function($event) {
            _vm.selectedStudent = $menteeIndex
          }
        }
      })])
    }))])], 2) : _vm._e()])]) : _vm._e()
  })) : _c('div', {
    staticClass: "no-checkins"
  }, [_vm._v("No checkins yet")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Weekly Check-In")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c04761e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MentorCheckins.vue
// module id = 2053
// module chunks = 2